import React from "react";
import styles from "./LeadershipSection.module.scss";
import LeaderShipBanner from "../../../assets/images/LeaderShipBanner.jpg";
import ShouryaK from "../../../assets/images/ShouryaK.jpg";
import SandipWelling from "../../../assets/images/SandipWeling.jpg";
import NeerajMAlik from "../../../assets/images/NeerajMalik.jpg";
import ParagDhakan from "../../../assets/images/ParagDhakan.jpg";
import PawanNawal from "../../../assets/images/PawanNawal.jpg";
import NehaMavani from "../../../assets/images/NehaMavani.jpg";
import LeadershipCard from "../../CustomComponent/LeadershipCard.tsx";
import BreadCrumb from "../../CommonComponents/BreadCrumb.tsx";

interface Person {
  imgSrc: string;
  name: string;
  designation: string;
}
interface leadPerson {
  imgSrc: string;
  name: string;
  designation: string;
}

const leadMember: leadPerson[] = [
  // {
  //   imgSrc: AtulJain,
  //   name: "Atul Jain",
  //   designation: "Managing Director & CEO",
  // },
];

const people: Person[] = [
  {
    imgSrc: SandipWelling,
    name: "Sandip Weling",
    designation: "Chief Business Officer (Global Retail)",
  },
  {
    imgSrc: NeerajMAlik,
    name: "Neeraj Malik",
    designation: "Chief Business Officer (EBG)",
  },
  {
    imgSrc: PawanNawal,
    name: "Pawan Nawal",
    designation: "Chief Financial Officer",
  },
  {
    imgSrc: ShouryaK,
    name: "Shourya K. Chakravarty",
    designation: "Chief Human Resources Officer",
  },
  {
    imgSrc: ParagDhakan,
    name: "Parag Dhakan",
    designation: "Executive Vice President & Head of Technology",
  },
  {
    imgSrc: NehaMavani,
    name: "Neha Mavani",
    designation: "Executive Vice President & Head of Marketing",
  },
];

const LeaderShipSection: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "About Us", link: "/about-us" },
    { title: "Our Leadership Team", link: "" },
  ];
  return (
    <div id="LeaderShipSection" className={styles.leaderShipSection}>
      <BreadCrumb menu={breadcrumb} />

      <Banner />
      <LeaderCardSection />
    </div>
  );
};
const Banner = () => {
  return (
    <div className="row g-0">
      <div className="col-12">
        <div className={styles.contentDiv}>
          <div className="container">
            <div className="row g-2">
              <div className="col-lg-6 col-md-12 col-sm-12 d-flex flex-column justify-content-center content">
                <div className="mt-5 mb-2">
                  <p className="heading">The Leaders at Aptech</p>
                  <p className="para">
                    With a wealth of expertise across various industries, each
                    member of the leadership team at Aptech brings valuable
                    expertise, strategic vision, and a commitment to delivering
                    impactful learning experiences to students and
                    professionals, driving the company’s growth globally. 
                  </p>
                  <p className="para">
                    The leadership team is dedicated to shaping the company’s
                    future while ensuring that students, faculty, as well as
                    business partners thrive in a dynamic and supportive
                    environment. 
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-12 col-sm-12 d-flex justify-content-center align-items-end">
                <img
                  src={LeaderShipBanner}
                  alt="AptechImage"
                  className={`${styles.partnerImage} img-fluid`}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
const LeaderCardSection = () => {
  return (
    <div className="container">
      <div
        className={`row ${styles.leadershipDiv} justify-content-center align-items-center`}
      >
        <p className="heading text-center mb-5">
          The Leadership Team at Aptech includes
        </p>

        {leadMember.map((leadPer, index) => (
          <div className="col-lg-4 col-md-6 col-sm-12 mb-4">
            <LeadershipCard
              imgSrc={leadPer.imgSrc}
              name={leadPer.name}
              designation={leadPer.designation}
            />
          </div>
        ))}
        <div className="row g-0">
          {people.map((person, index) => (
            <div
              className={`${styles.LeadershipCardBox} col-lg-4 col-md-6 col-sm-12 mb-4`}
              key={index}
            >
              <LeadershipCard
                imgSrc={person.imgSrc}
                name={person.name}
                designation={person.designation}
              />
            </div>
          ))}
        </div>
        <div className="section">
        <p className={`para text-center pt-4 ${styles.bottomPara}`}>
          The leaders at Aptech, together, guide students, faculty, and business
          partners towards a future where learning and knowledge knows no
          limits. 
        </p>
        </div>
      </div>
    </div>
  );
};
export default LeaderShipSection;
